import { render, staticRenderFns } from "./xeDoughnut.vue?vue&type=template&id=98feed70&scoped=true"
import script from "./xeDoughnut.vue?vue&type=script&lang=js"
export * from "./xeDoughnut.vue?vue&type=script&lang=js"
import style0 from "./xeDoughnut.vue?vue&type=style&index=0&id=98feed70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98feed70",
  null
  
)

export default component.exports